module.exports = __webpack_public_path__ + "static/media/icon-check-fill.98eab9f8.svg";